/** Line-item-wise GST — mirror of backend financials.compute_taxes. Each line may carry its
 *  own gst_rate (5 / 12 / 18 …); lines without one use the document default. One
 *  intra/inter-state split applies to the whole document. */
export const hasOwnRate = (it) => it.gst_rate !== null && it.gst_rate !== undefined && it.gst_rate !== "";
export const lineRate = (it, defaultRate) => hasOwnRate(it) ? (parseFloat(it.gst_rate) || 0) : defaultRate;

/** Mirror of backend `compute_taxes`: per-line GST (own rate or the document default),
 *  one intra/inter-state split for the whole document, rate-wise breakup for the summary. */
export function computeDocTaxes(items, form) {
  const defaultRate = (parseFloat(form.cgst_rate) || 0) + (parseFloat(form.sgst_rate) || 0) + (parseFloat(form.igst_rate) || 0);
  const inter = (parseFloat(form.igst_rate) || 0) > 0 && !(parseFloat(form.cgst_rate) || parseFloat(form.sgst_rate));
  const by = {};
  let subtotal = 0, cgst = 0, sgst = 0, igst = 0;
  for (const it of items || []) {
    const taxable = (parseFloat(it.quantity) || 0) * (parseFloat(it.rate) || 0);
    const r = lineRate(it, defaultRate);
    const tax = taxable * r / 100;
    const c = inter ? 0 : tax / 2, sg = inter ? 0 : tax / 2, ig = inter ? tax : 0;
    subtotal += taxable; cgst += c; sgst += sg; igst += ig;
    const b = by[r] || (by[r] = { rate: r, taxable: 0, cgst: 0, sgst: 0, igst: 0 });
    b.taxable += taxable; b.cgst += c; b.sgst += sg; b.igst += ig;
  }
  const breakup = Object.values(by).sort((a, b) => a.rate - b.rate);
  const used = breakup.filter(b => b.taxable > 0);
  const mixed = used.length > 1;
  // the rate the totals were computed at when every line agrees (labels must match amounts)
  const docRate = used.length === 1 ? used[0].rate : defaultRate;
  return { subtotal, cgst, sgst, igst, breakup, mixed, defaultRate, docRate, inter };
}


/** Solar composite 70:30 — mirror of backend financials.composite_lines(): each line becomes a goods leg
 *  (70% @ 5%, HSN 8541) and a services leg (30% @ 18%, SAC 9954). Effective 8.9%. */
export const TAX_TREATMENTS = [
  ["services_18", "Services — 18% on the full value (SAC 9954)"],
  ["solar_composite_70_30", "Solar power generating system — composite 70:30 (5% / 18%, 8.9% effective)"],
];
export function compositeLines(items) {
  const out = [];
  (items || []).forEach((it, n) => {
    const base = Math.round(((parseFloat(it.quantity) || 0) * (parseFloat(it.rate) || 0)) * 100) / 100;
    const goods = Math.round(base * 0.7 * 100) / 100, services = Math.round((base - goods) * 100) / 100;
    out.push({ source: n, leg: "goods", description: `${it.description || ""} — goods (70%)`, hsn_code: "8541", quantity: 1, unit: "lot", rate: goods, amount: goods, gst_rate: 5 });
    out.push({ source: n, leg: "services", description: `${it.description || ""} — installation & commissioning services (30%)`, hsn_code: "9954", quantity: 1, unit: "lot", rate: services, amount: services, gst_rate: 18 });
  });
  return out;
}
